define.alias("shared/modifiers/animate-typewriter", "preview-grid/modifiers/animate-typewriter");